import { render, staticRenderFns } from "./detailEvents.vue?vue&type=template&id=775ca696&scoped=true"
import script from "./detailEvents.vue?vue&type=script&lang=ts"
export * from "./detailEvents.vue?vue&type=script&lang=ts"
import style0 from "./detailEvents.vue?vue&type=style&index=0&id=775ca696&prod&lang=scss&scoped=true"
import style1 from "./detailEvents.vue?vue&type=style&index=1&id=775ca696&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775ca696",
  null
  
)

export default component.exports